/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
import userManagement from "./user-management/moduleUserManagement"
import historyManagement from "./history-management/moduleHistoryManagement"
import statementManagement from "./statement-management/moduleStatementManagement"
import agentManagement from "./agent-management/moduleAgentManagement"
import masterManagement from "./master-management/moduleMasterManagement"
import dashboard from "./dashboard/moduleDashboardManagement"
import report from "./report/moduleReportManagement"
import promotionManagement from "./promotion/modulePromotionManagement"

Vue.use(Vuex)
import moduleAuth from './auth/moduleAuth.js'
export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
      auth: moduleAuth,
      userManagement,
      historyManagement,
      statementManagement,
      agentManagement,
      masterManagement,
      dashboard,
      report,
      promotionManagement
    },
    strict: false,//process.env.NODE_ENV !== 'production'
})
